import React, { useEffect, useState } from 'react';
import { Box, Text, FormControl, FormLabel, Input, Select, Button, SimpleGrid, Divider, Checkbox, Flex } from '@chakra-ui/react';
import { useBoardContext } from '../context/BoardContext';
import { boardMembers } from '../components/BoardSidebar';
const TEAL = '#00897B';
const BORDER_COLOR = '#006666';
const terms = ['1st', '2nd', '3rd'];
const officeOptions = ['President', 'Vice President'];
function parseName(fullName: string): {
  firstName: string;
  lastName: string;
} {
  if (!fullName || fullName === 'Vacant' || fullName === '(Vacant)') return {
    firstName: '',
    lastName: ''
  };
  const parts = fullName.trim().split(' ');
  const firstName = parts[0] || '';
  const lastName = parts.slice(1).join(' ') || '';
  return {
    firstName,
    lastName
  };
}
const inputStyles = {
  borderColor: 'gray.300',
  focusBorderColor: TEAL,
  _hover: {
    borderColor: TEAL
  },
  size: 'sm' as const,
  bg: 'white'
};
const labelStyles = {
  fontSize: 'xs' as const,
  fontWeight: '600' as const,
  color: TEAL,
  textTransform: 'uppercase' as const,
  letterSpacing: '0.05em',
  mb: 0.5
};
export function BoardPage() {
  const {
    selectedIndex
  } = useBoardContext();
  const selected = boardMembers[selectedIndex];
  const {
    firstName: initFirst,
    lastName: initLast
  } = parseName(selected.name);
  const [firstName, setFirstName] = useState(initFirst);
  const [lastName, setLastName] = useState(initLast);
  const [company, setCompany] = useState('');
  const [homePhone, setHomePhone] = useState('');
  const [cell, setCell] = useState('');
  const [email, setEmail] = useState('');
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [term, setTerm] = useState(terms[0]);
  const [startDate, setStartDate] = useState('');
  const [termEndDate, setTermEndDate] = useState('');
  const [isOfficer, setIsOfficer] = useState(false);
  const [office, setOffice] = useState(officeOptions[0]);
  useEffect(() => {
    const {
      firstName: f,
      lastName: l
    } = parseName(boardMembers[selectedIndex].name);
    setFirstName(f);
    setLastName(l);
    setCompany('');
    setHomePhone('');
    setCell('');
    setEmail('');
    setStreet('');
    setCity('');
    setState('');
    setZip('');
    setTerm(terms[0]);
    setStartDate('');
    setTermEndDate('');
    setIsOfficer(false);
    setOffice(officeOptions[0]);
  }, [selectedIndex]);
  const handleSave = () => {
    console.log('Saving board member...');
  };
  return <Box px={6} py={3} maxW="720px" data-id="element-195">
      <Text fontSize="xl" fontWeight="bold" color="black" mb={3} data-id="element-196">
        Edit Board Member: WPGA - WA
      </Text>

      <Box border={`2px solid ${BORDER_COLOR}`} borderRadius="md" bg="white" p={4} data-id="element-197">
        {/* Name row */}
        <SimpleGrid columns={2} spacing={3} mb={3} data-id="element-198">
          <FormControl data-id="element-199">
            <FormLabel {...labelStyles} data-id="element-200">First Name</FormLabel>
            <Input {...inputStyles} value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="First Name" data-id="element-201" />
          </FormControl>
          <FormControl data-id="element-202">
            <FormLabel {...labelStyles} data-id="element-203">Last Name</FormLabel>
            <Input {...inputStyles} value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Last Name" data-id="element-204" />
          </FormControl>
        </SimpleGrid>

        <FormControl mb={3} data-id="element-205">
          <FormLabel {...labelStyles} data-id="element-206">Company/Farm Name</FormLabel>
          <Input {...inputStyles} value={company} onChange={e => setCompany(e.target.value)} placeholder="Company/Farm Name" data-id="element-207" />
        </FormControl>

        {/* Address block */}
        <FormControl mb={3} data-id="element-208">
          <FormLabel {...labelStyles} data-id="element-209">Street Address</FormLabel>
          <Input {...inputStyles} value={street} onChange={e => setStreet(e.target.value)} placeholder="Street Address" data-id="element-210" />
        </FormControl>

        <SimpleGrid columns={3} spacing={3} mb={3} data-id="element-211">
          <FormControl data-id="element-212">
            <FormLabel {...labelStyles} data-id="element-213">City</FormLabel>
            <Input {...inputStyles} value={city} onChange={e => setCity(e.target.value)} placeholder="City" data-id="element-214" />
          </FormControl>
          <FormControl data-id="element-215">
            <FormLabel {...labelStyles} data-id="element-216">State</FormLabel>
            <Input {...inputStyles} value={state} onChange={e => setState(e.target.value)} placeholder="State" maxLength={2} data-id="element-217" />
          </FormControl>
          <FormControl data-id="element-218">
            <FormLabel {...labelStyles} data-id="element-219">Zip</FormLabel>
            <Input {...inputStyles} value={zip} onChange={e => setZip(e.target.value)} placeholder="Zip" data-id="element-220" />
          </FormControl>
        </SimpleGrid>

        {/* Phone fields */}
        <SimpleGrid columns={2} spacing={3} mb={3} data-id="element-221">
          <FormControl data-id="element-222">
            <FormLabel {...labelStyles} data-id="element-223">Home/Business Phone</FormLabel>
            <Input {...inputStyles} value={homePhone} onChange={e => setHomePhone(e.target.value)} placeholder="Home/Business Phone" type="tel" data-id="element-224" />
          </FormControl>
          <FormControl data-id="element-225">
            <FormLabel {...labelStyles} data-id="element-226">Cell</FormLabel>
            <Input {...inputStyles} value={cell} onChange={e => setCell(e.target.value)} placeholder="Cell" type="tel" data-id="element-227" />
          </FormControl>
        </SimpleGrid>

        {/* Email */}
        <FormControl mb={3} data-id="element-228">
          <FormLabel {...labelStyles} data-id="element-229">Email</FormLabel>
          <Input {...inputStyles} value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" type="email" data-id="element-230" />
        </FormControl>

        <Divider borderColor="gray.200" my={3} data-id="element-231" />

        {/* Term + Officer row — flex-end aligns both dropdowns */}
        <Flex gap={3} align="flex-end" mb={3} data-id="element-232">
          <FormControl flex={1} data-id="element-233">
            <FormLabel {...labelStyles} data-id="element-234">Term</FormLabel>
            <Select value={term} onChange={e => setTerm(e.target.value)} borderColor="gray.300" focusBorderColor={TEAL} _hover={{
            borderColor: TEAL
          }} size="sm" bg="white" data-id="element-235">
              {terms.map(t => <option key={t} value={t} data-id="element-236">
                  {t}
                </option>)}
            </Select>
          </FormControl>

          <Box flex={1} data-id="element-237">
            <Checkbox isChecked={isOfficer} onChange={e => setIsOfficer(e.target.checked)} colorScheme="teal" size="md" mb={1} data-id="element-238">
              <Text fontSize="xs" fontWeight="600" color={TEAL} textTransform="uppercase" letterSpacing="0.05em" data-id="element-239">
                This is an Officer
              </Text>
            </Checkbox>
            {isOfficer ? <Select value={office} onChange={e => setOffice(e.target.value)} borderColor="gray.300" focusBorderColor={TEAL} _hover={{
            borderColor: TEAL
          }} size="sm" bg="white" data-id="element-240">
                {officeOptions.map(o => <option key={o} value={o} data-id="element-241">
                    {o}
                  </option>)}
              </Select> /* Invisible placeholder keeps height consistent */ : <Box h="32px" data-id="element-242" />}
          </Box>
        </Flex>

        {/* Dates */}
        <SimpleGrid columns={2} spacing={3} mb={4} data-id="element-243">
          <FormControl data-id="element-244">
            <FormLabel {...labelStyles} data-id="element-245">Term Start Date</FormLabel>
            <Input {...inputStyles} value={startDate} onChange={e => setStartDate(e.target.value)} type="date" data-id="element-246" />
          </FormControl>
          <FormControl data-id="element-247">
            <FormLabel {...labelStyles} data-id="element-248">Term End Date</FormLabel>
            <Input {...inputStyles} value={termEndDate} onChange={e => setTermEndDate(e.target.value)} type="date" data-id="element-249" />
          </FormControl>
        </SimpleGrid>

        {/* Bottom row: VACANT checkbox, buttons, and key */}
        <Flex gap={4} align="center" data-id="element-250">
          <Checkbox colorScheme="teal" size="md" data-id="element-251">
            <Text fontSize="sm" fontWeight="600" color={TEAL} textTransform="uppercase" data-id="element-252">
              Vacant
            </Text>
          </Checkbox>

          <Flex gap={2} data-id="element-253">
            <Button bg="gray.500" color="white" px={8} size="sm" borderRadius="md" fontWeight="semibold" _hover={{
            bg: 'gray.600'
          }} _active={{
            bg: 'gray.700'
          }} data-id="element-254">
              Clear
            </Button>
            <Button bg="#0d6dfc" color="white" px={8} size="sm" borderRadius="md" fontWeight="semibold" _hover={{
            bg: '#0b5fd9'
          }} _active={{
            bg: '#0a52be'
          }} onClick={handleSave} data-id="element-255">
              Save
            </Button>
          </Flex>

          <Box border="1px solid" borderColor="gray.400" borderRadius="md" px={3} py={2} ml="auto" bg="gray.50" data-id="element-256">
            <Text fontSize="xs" color="gray.700" lineHeight="1.4" data-id="element-257">
              <Text as="span" fontWeight="bold" data-id="element-258">
                Vacant
              </Text>{' '}
              = Open Position
            </Text>
            <Text fontSize="xs" color="gray.700" lineHeight="1.4" data-id="element-259">
              Click{' '}
              <Text as="span" fontWeight="bold" data-id="element-260">
                Clear
              </Text>{' '}
              to empty the boxes so you can
            </Text>
            <Text fontSize="xs" color="gray.700" lineHeight="1.4" data-id="element-261">
              enter new values.
            </Text>
          </Box>
        </Flex>
      </Box>
    </Box>;
}